import {Schema, Collection} from "@oilstone/rest-model-repository";
import Factory from '../factory';

const schema = Factory.schema('poster-board');
const attributes = schema.getProp('attributes').getValue();
const item = new Schema();

item.prop('title').setType(String).setValue('Title');
item.prop('summary').setType(String).setValue('Summary...');
item.prop('image').setType(String).setValue('image-placeholder.svg');
item.prop('imageAlt').setType(String);
item.prop('btnText').setType(String).setValue('Read more');
item.prop('btnLink').setType(String).setValue('#');

attributes.prop('items').setType(Collection).setValue(new Collection(item));

export default schema;
